import { motion } from "framer-motion"

function KeepFeeling() {
  return (
    <section className="relative flex min-h-[70vh] w-full flex-col items-center justify-center bg-[#080808] px-8 py-32 text-center md:min-h-screen">
      <motion.p
        className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]"
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        09
      </motion.p>
      <motion.h2
        className="font-display mt-10 text-4xl italic text-[#f7f1e6] md:text-7xl"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4 }}
      >
        KEEP THE FEELING.
      </motion.h2>
      <motion.p
        className="font-serif-tc mt-10 text-sm tracking-[0.12em] text-stone-400 md:text-xl"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, delay: 0.2 }}
      >
        一首歌、一個故事、一種味道
      </motion.p>
    </section>
  )
}

export default KeepFeeling
